import { __rest } from "tslib";
import * as React from 'react';
/** @internal Only used for Dropdown component. Do not use this in your production. */
const OverrideContext = React.createContext(null);
/** @internal Only used for Dropdown component. Do not use this in your production. */
export const OverrideProvider = (_a) => {
    var { children } = _a, restProps = __rest(_a, ["children"]);
    const override = React.useContext(OverrideContext);
    const context = React.useMemo(() => (Object.assign(Object.assign({}, override), restProps)), [
        override,
        restProps.prefixCls,
        // restProps.expandIcon, Not mark as deps since this is a ReactNode
        restProps.mode,
        restProps.selectable,
        // restProps.validator, Not mark as deps since this is a function
    ]);
    return React.createElement(OverrideContext.Provider, { value: context }, children);
};
export default OverrideContext;
